// src/pages/NoRolePage.tsx
import { Box, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export function NoRolePage() {
  const { user } = useAuth();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
      sx={{ p: 3, maxWidth: 600, mx: 'auto' }}
    >
      <Typography variant="h4" component="h1">
        Role Assignment Required
      </Typography>
      <Alert severity="warning" sx={{ width: '100%' }}>
        Your account needs a role assignment to access the application.
      </Alert>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {user ? (
          <>
            Your account ({user.email}) has been authenticated, but no role has been assigned yet.
            Please contact an administrator to assign you a role.
          </>
        ) : (
          'Please contact an administrator to assign you a role.'
        )}
      </Typography>
    </Box>
  );
}

